import React from 'react'
import Icon from '@ant-design/icons';

export default (props) => {
  const {
    color = '#919191', // цвет знака
  } = props;

  const icon_color = color || 'currentColor';

  const SvgIcon = () => (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2456 0H1.75439C0.77193 0 0 0.967032 0 2.1978V13.8022C0 15.033 0.77193 16 1.75439 16H14.4561C14.6667 16 14.807 15.8242 14.807 15.5604C14.807 15.2967 14.6667 15.1209 14.4561 15.1209H1.75439C1.15789 15.1209 0.701754 14.5494 0.701754 13.8022V2.1978C0.701754 1.93407 0.77193 1.67033 0.877193 1.49451L9.78947 9.89011C9.85965 9.93407 9.92982 9.97802 10 9.97802C10.0702 9.97802 10.1404 9.93407 10.2105 9.89011L19.1228 1.49451C19.2281 1.71429 19.2982 1.93407 19.2982 2.1978V13.8022C19.2982 14.5494 18.8421 15.1209 18.2456 15.1209H15.8596C15.6491 15.1209 15.5088 15.2967 15.5088 15.5604C15.5088 15.8242 15.6491 16 15.8596 16H18.2456C19.2281 16 20 15.033 20 13.8022V2.1978C20 1.01099 19.2281 0 18.2456 0ZM10 8.96703L1.47368 0.923077C1.57895 0.879121 1.64912 0.879121 1.75439 0.879121H18.2456C18.3509 0.879121 18.4561 0.923077 18.5263 0.923077L10 8.96703Z"
        fill={icon_color}
      />
    </svg>
  );

  return <Icon component={SvgIcon} {...props} />;
}
